import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLighting = () => {
  return (
    <g>
      <path d="m11.6086 7.25h-5.4067l5.937-5.9365a.75.75 0 0 0 -1.0605-1.0606l-7.2173 7.2171a.75.75 0 0 0 .53 1.28h5.407l-5.937 5.9365a.75.75 0 1 0 1.0605 1.0605l7.2173-7.217a.75.75 0 0 0 -.53-1.28z" />
    </g>
  );
};

export default withIcon(IconLighting);
